/**
 * Auto-generated file - do not edit by hand
 * Run `pnpm ui:generate:icons` to regenerate
 * Source: source/svg/chevronDown.svg
 */
import type { IconProps } from '../types';
const ChevronDown = ({ size, ...props }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={size}
    height={size}
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.24 9.123a.9.9 0 0 1 1.274 0l4.969 4.969c.208.208.327.326.42.405l.058.046q.015.003.031 0 .017-.011.06-.046c.093-.079.212-.197.42-.405l4.969-4.969.068-.062a.9.9 0 0 1 1.267 1.266l-.063.068-4.968 4.97c-.187.187-.366.367-.528.504-.17.144-.38.294-.652.383a1.9 1.9 0 0 1-1.175 0l-.193-.077a2.1 2.1 0 0 1-.46-.306c-.162-.137-.34-.317-.528-.505L5.24 10.395a.9.9 0 0 1 0-1.272"
    />
  </svg>
);
export default ChevronDown;
